import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../../../Components/helper';

export function ContainerColumnConfig({ data, array, changetarget }) {
  const { t } = useTranslation('common');
  return (
    <>
      <span className="p-2 d-block f-14">{data?.label}</span>
      <table width="100%" className="field-tbl px-2 f-14">
        <thead>
          <th style={{ width: '25%' }}> {t('CUSTOM_MODULE.LABEL')}</th>
          <th>{t('CUSTOM_MODULE.VISIBLE_SUPPLIER')}</th>
          <th>{t('CUSTOM_MODULE.EDITABLE_SUPPLIER')}</th>
        </thead>
        <tbody>
          {checkArray(array) ? (
            array?.map((element, index) => {
              return (
                <tr key={element}>
                  <td>{element?.label}</td>
                  <td>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="checkbox-label">
                        <input
                          type="checkbox"
                          id={`${element?.label}_${index}_Required`}
                          name={element?.label}
                          checked={element?.supplierVisible}
                          onChange={(e) => changetarget(e, index, 'supplierVisible')}
                        />
                        <label htmlFor={`${element?.label}_${index}_Required`} className="chklabel" />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="checkbox-label">
                        <input
                          type="checkbox"
                          id={`${element?.label}_${index}_Enable`}
                          name={element?.label}
                          checked={element?.supplierEditable}
                          onChange={(e) => changetarget(e, index, 'supplierEditable')}
                        />
                        <label htmlFor={`${element?.label}_${index}_Enable`} className="chklabel" />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>
                <span className="align-items-center justify-content-center d-flex">{`No Element found in ${data?.label}`}</span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
}

export default ContainerColumnConfig;
